import { getElements } from '~/packages/utils';
import { IServiceLocator } from '~/services';
import { IAmComponent, IAmComponentClass } from '~/ui/components/AbstractComponent';

/**
 * Creates component instances attached to matched element
 *
 * @param items
 * @param locator
 */
export default function mount(items: TComponentConfig[], locator: IServiceLocator) {
    const instances: IAmComponent[] = [];

    items.forEach(item => {
        const isConfig = 'component' in item;
        const component = isConfig ? item.component! : item;
        const options = isConfig ? item.options || {} : {};
        const name = component.name;
        const attribute = 'data-am-' + name.toLowerCase();

        getElements(`[${attribute}]`, options.parent).forEach(el => {
            const cNames: string[] = (<any>el)._amComponents = (<any>el)._amComponents || [];

            if (cNames.indexOf(name) !== -1) {
                console && console.warn(`${name} is already mounted to [${attribute}], skipping`);
                return;
            }

            const instance = new component(el, attribute, locator);
            instance.onMount && instance.onMount();

            instances.push(instance);
            cNames.push(name);
        });
    });

    return instances;
}

type TMountOptions = {
    // custom name of the component. By default, matches the class name
    name?: string;

    // parent element to look for a component. Defaults to document
    parent?: Document|HTMLElement;
}

type TConfig = {
    component: IAmComponentClass,
    options?: TMountOptions,
}

export type TComponentConfig = (IAmComponentClass | TConfig)
